import { cn } from "@/lib/utils";

interface StewAvatarProps {
  size?: number;
  className?: string;
}

/**
 * Small circular identity mark for Stew. Deep-green fill, gold border,
 * serif capital S. Sits beside Stew's messages and the greeting.
 */
export function StewAvatar({ size = 32, className }: StewAvatarProps) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        "shrink-0 rounded-full border-2 border-gold flex items-center justify-center select-none",
        className,
      )}
      style={{
        width: size,
        height: size,
        backgroundColor: "#1F3D2B",
        color: "#FAF7F0",
        fontFamily: "'Cormorant Garamond', 'Playfair Display', Georgia, serif",
        fontWeight: 600,
        fontSize: Math.round(size * 0.55),
        lineHeight: 1,
      }}
    >
      S
    </div>
  );
}
